module.exports = __webpack_public_path__ + "img/pooja.e14b161b.png";